<template>
  <div class="min-h-screen bg-background">
    <router-view />
  </div>
</template>
